import { Link } from "react-router-dom";
import { BRAND, waLink } from "../../brand";
import { Instagram, Facebook, Mail, Phone, ArrowUpRight } from "lucide-react";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.42v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.6 20.1a6.34 6.34 0 0 0 10.86-4.43V8.39a8.16 8.16 0 0 0 4.77 1.52V6.49a4.85 4.85 0 0 1-1.64-.2z" />
  </svg>
);

const cols = [
  {
    title: "Servicios",
    items: [
      { l: "Automatización con IA", to: "/automatizacion-ia" },
      { l: "Respond.io", to: "/respond-io" },
      { l: "Funnels", to: "/funnels" },
      { l: "Casos de éxito", to: "/casos-de-exito" },
    ],
  },
  {
    title: "Publicidad",
    items: [
      { l: "Google Ads", to: "/google-ads" },
      { l: "Meta Ads", to: "/meta-ads" },
      { l: "TikTok Ads", to: "/tiktok-ads" },
      { l: "Contacto", to: "/contacto" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative pt-24 pb-12 border-t border-white/5">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-3" data-testid="footer-logo-link">
              <img src={BRAND.logo} alt="Daos Ads" className="w-12 h-12 rounded-xl ring-1 ring-white/10" />
              <div>
                <div className="font-display font-bold text-white text-xl">Daos Ads</div>
                <div className="text-[11px] tracking-[0.18em] uppercase text-[#ff8a00] font-display">Gana más, pierde cero</div>
              </div>
            </Link>
            <p className="mt-6 text-zinc-400 max-w-md">
              Implemento sistemas de automatización omnicanal, IA conversacional y publicidad digital para empresas que quieren escalar ventas sin perder oportunidades.
            </p>

            <div className="mt-7 flex items-center gap-3">
              <a href={BRAND.socials.instagram} target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full glass grid place-items-center hover:border-[#ff8a00]/50 transition" data-testid="footer-instagram">
                <Instagram className="w-4 h-4 text-zinc-300" />
              </a>
              <a href={BRAND.socials.facebook} target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full glass grid place-items-center hover:border-[#ff8a00]/50 transition" data-testid="footer-facebook">
                <Facebook className="w-4 h-4 text-zinc-300" />
              </a>
              <a href={BRAND.socials.tiktok} target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full glass grid place-items-center hover:border-[#ff8a00]/50 transition" data-testid="footer-tiktok">
                <TikTokIcon className="w-4 h-4 text-zinc-300" />
              </a>
              <a href={waLink()} target="_blank" rel="noreferrer" className="ml-2 inline-flex items-center gap-2 px-4 h-11 rounded-full bg-[#25D366] text-white font-display font-semibold text-sm" data-testid="footer-whatsapp">
                <span className="w-2 h-2 rounded-full bg-white pulse-dot" />
                WhatsApp
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 grid grid-cols-2 gap-6">
            {cols.map((c) => (
              <div key={c.title}>
                <div className="text-white font-display font-semibold text-sm mb-4">{c.title}</div>
                <ul className="space-y-2.5">
                  {c.items.map((it) => (
                    <li key={it.l}>
                      <Link to={it.to} className="text-zinc-400 text-sm hover:text-white transition">{it.l}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:col-span-3">
            <div className="text-white font-display font-semibold text-sm mb-4">Contacto</div>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 text-zinc-400 hover:text-white">
                  <Mail className="w-4 h-4" /> {BRAND.email}
                </a>
              </li>
              <li>
                <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-zinc-400 hover:text-white">
                  <Phone className="w-4 h-4" /> {BRAND.whatsappNumber}
                </a>
              </li>
            </ul>

            <Link to="/contacto" className="btn-primary mt-7 !py-3 !px-5 text-sm" data-testid="footer-cta">
              Agenda una consultoría <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/5 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} Daos Ads · Todos los derechos reservados.</div>
          <div className="flex items-center gap-2">
            <span>Diseñado para</span>
            <span className="text-gradient font-display font-bold">conversión real</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
